export default "__VITE_ASSET__$kPEd3xL__"